import * as Yup from "yup";

const saleItemSchema = Yup.object().shape({
    idItem: Yup.string().required("ID do item é obrigatório"),
    name: Yup.string().required("Nome do item é obrigatório"),
    // Tipos de itens que geram vendas
    type: Yup.string().oneOf(["membership", "product", "event", "service", "physical_test"]).required(),
    quantity: Yup.number().positive().default(1),
    unitPrice: Yup.number().min(0).required(),
    totalPrice: Yup.number().min(0).required(),
    discount: Yup.number().min(0).default(0),

    // Props específicas que vêm atreladas caso type == 'membership'
    duration: Yup.number().nullable(),
    durationType: Yup.string().nullable(), // 'monthly', 'days', 'yearly'
    enrollmentRequired: Yup.boolean().nullable(),
    
    memberXp: Yup.number().nullable(),
    employeeXp: Yup.number().nullable(),
    
    isScholarship: Yup.boolean().nullable(),
    allowsSuspension: Yup.boolean().nullable(),
    maxSuspensionDays: Yup.number().nullable(),
    suspensionFee: Yup.number().nullable(),
    cancellationFee: Yup.number().nullable(),
    cancellationNoticeDays: Yup.number().nullable(),
    allowsCancellationByApp: Yup.boolean().nullable()
});

const paymentMethodSchema = Yup.object().shape({
    idMethod: Yup.string().oneOf(["CREDIT_CARD", "DEBIT_CARD", "PIX", "CASH", "BOLETO", "TRANSFER"]).required(),
    installments: Yup.number().integer().min(1).default(1),
    amount: Yup.number().positive().required("Valor do pagamento obrigatório")
});

export const saleSchema = Yup.object().shape({
    idMember: Yup.string().required("Identifique o cliente/membro"),
    memberName: Yup.string().required(),
    
    idEmployee: Yup.string().required("Identifique o vendedor"),
    employeeName: Yup.string().required(),

    date: Yup.date().required(),

    // O Carrinho não pode estar vazio!
    items: Yup.array()
        .of(saleItemSchema)
        .min(1, "O carrinho deve ter pelo menos 1 item")
        .required(),

    subtotal: Yup.number().min(0).required(),
    discountTotal: Yup.number().min(0).default(0),
    totalAmount: Yup.number().min(0).required(),

    // Como ele pagou as contas
    paymentMethods: Yup.array()
        .of(paymentMethodSchema)
        .min(1, "Informe ao menos um método de pagamento")
        .required(),

    couponCode: Yup.string().nullable(),
    couponDiscountValue: Yup.number().min(0).default(0),

    status: Yup.string()
        .oneOf(["PENDING", "COMPLETED", "CANCELED", "REFUNDED"])
        .default("COMPLETED"),

    notes: Yup.string().nullable()
});
